import { Component, effect, inject, OnInit, signal } from '@angular/core';

import { ActivatedRoute, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';
import { TranslatePipe } from '@ngx-translate/core';
import { EmailPasswordLoginComponent } from "./components/email-password-login/email-password-login.component";
import { OtpLoginComponent } from "./components/otp-login/otp-login.component";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, AuthLayoutComponent, TranslatePipe, EmailPasswordLoginComponent, OtpLoginComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private static readonly LOGIN_TYPE_LAST_USED_KEY = "loginTypeLastUsed";

  private readonly route = inject(ActivatedRoute);

  protected errorMessage = signal<string | null>(null);
  protected loginType = signal<'email' | 'otp'>('email');

  constructor() {
    effect(() => {
      localStorage.setItem(LoginComponent.LOGIN_TYPE_LAST_USED_KEY, this.loginType());
    })
  }

  ngOnInit(): void {
    localStorage.getItem(LoginComponent.LOGIN_TYPE_LAST_USED_KEY) === 'otp' 
      ? this.loginType.set('otp') 
      : this.loginType.set('email');

    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        this.errorMessage.set(params['error']);
      }

      if (params['otp']) {
        this.loginType.set('otp');
      }
    });
  }
}
